// Animated diamond grid background — adapted from reactbits.dev/backgrounds/shape-grid.
// Attaches to any `[data-shape-grid]` element. Kept as plain JS (not Alpine) because
// it's a canvas + requestAnimationFrame loop, which Alpine adds nothing to.
const GRID_SIZE = 40
const SPEED = 0.35
const BG = "#0F2B52"
const LINE = "#ffffff"
const LINE_OPACITY = 0.12

function attach(el) {
  const canvas = document.createElement("canvas")
  canvas.style.cssText =
    "position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:0;"
  el.style.position = "relative"
  el.prepend(canvas)

  const ctx = canvas.getContext("2d")
  const offset = { x: 0, y: 0 }

  const resize = () => {
    canvas.width = el.offsetWidth
    canvas.height = el.offsetHeight
  }
  window.addEventListener("resize", resize)
  resize()

  const draw = () => {
    const { width: w, height: h } = canvas
    ctx.clearRect(0, 0, w, h)
    ctx.fillStyle = BG
    ctx.fillRect(0, 0, w, h)

    ctx.strokeStyle = LINE
    ctx.globalAlpha = LINE_OPACITY
    ctx.lineWidth = 1
    const cols = Math.ceil(w / GRID_SIZE) + 2
    const rows = Math.ceil(h / GRID_SIZE) + 2
    for (let col = -1; col < cols; col++) {
      for (let row = -1; row < rows; row++) {
        ctx.strokeRect(col * GRID_SIZE + offset.x, row * GRID_SIZE + offset.y, GRID_SIZE, GRID_SIZE)
      }
    }
    ctx.globalAlpha = 1

    // Radial vignette, matching the CSS fallback in `.hero-shape-grid`
    const grad = ctx.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, Math.max(w, h) * 0.6)
    grad.addColorStop(0.4, "rgba(15,43,82,0)")
    grad.addColorStop(1.0, "rgba(15,43,82,1)")
    ctx.fillStyle = grad
    ctx.fillRect(0, 0, w, h)
  }

  const tick = () => {
    offset.x = (((offset.x - SPEED) % GRID_SIZE) + GRID_SIZE) % GRID_SIZE
    offset.y = (((offset.y - SPEED) % GRID_SIZE) + GRID_SIZE) % GRID_SIZE
    draw()
    requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-shape-grid]").forEach(attach)
})
